var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import styled, { css } from 'styled-components';
import * as React from 'react';
import ValidationTooltip from '../tooltip/validation-tooltip';
import { Color, Size } from '../const/';
var TextField = (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocus: false,
        };
        _this.handleFocus = function (e) {
            _this.setState(__assign({}, _this.state, { isFocus: true }));
            _this.props.onFocus && _this.props.onFocus(e);
        };
        _this.handleBlur = function (e) {
            _this.props.onBlur && _this.props.onBlur(e);
            _this.setState(__assign({}, _this.state, { isFocus: false }));
        };
        _this.getDisplayValue = function () {
            var _a = _this.props, formatOnBlur = _a.formatOnBlur, value = _a.value;
            var isFocus = _this.state.isFocus;
            if (formatOnBlur) {
                return value || value === 0 ? (isFocus ? value : formatOnBlur(value)) : '';
            }
            else {
                return value;
            }
        };
        return _this;
    }
    TextField.prototype.focus = function () {
        this.input && this.input.focus();
    };
    TextField.prototype.blur = function () {
        this.input && this.input.blur();
    };
    TextField.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly, invalidMessage = _a.invalidMessage, getTooltipContainer = _a.getTooltipContainer, toolTipPlacement = _a.toolTipPlacement, align = _a.align, type = _a.type, restProps = __rest(_a, ["className", "isDisabled", "isReadOnly", "invalidMessage", "getTooltipContainer", "toolTipPlacement", "align", "type"]);
        return (React.createElement(ValidationTooltip, { placement: toolTipPlacement || 'topLeft', visible: typeof invalidMessage === 'string' && invalidMessage.length > 0, invalidMessage: invalidMessage, getTooltipContainer: getTooltipContainer || (function () { return _this.container; }) },
            React.createElement("div", { ref: function (ref) {
                    _this.container = ref;
                }, style: { width: '100%' } },
                React.createElement(StyledTextField, { align: align, className: className, invalidMessage: invalidMessage },
                    React.createElement("input", __assign({}, restProps, { type: type || 'text', disabled: isDisabled, readOnly: isReadOnly, value: this.getDisplayValue(), onFocus: this.handleFocus, onBlur: this.handleBlur, ref: function (ref) { return (_this.input = ref); } }))))));
    };
    return TextField;
}(React.Component));
var StyledTextField = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  > input {\n    appearance: none;\n    border: ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    color: ", ";\n    font-size: 14px;\n    height: ", "px;\n    line-height: normal;\n    padding: 8px 12px;\n    -webkit-tap-highlight-color: transparent;\n    width: 100%;\n    ", " &::placeholder {\n      color: ", ";\n    }\n    &:-ms-input-placeholder {\n      color: ", ";\n    }\n    &:hover,\n    &:focus {\n      border-color: ", ";\n    }\n    &:disabled {\n      background: ", ";\n      opacity: 0.3;\n      &:hover {\n        border-color: ", ";\n      }\n    }\n    &:read-only {\n      border: none;\n      padding: none;\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  > input {\n    appearance: none;\n    border: ",
    ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    color: ", ";\n    font-size: 14px;\n    height: ", "px;\n    line-height: normal;\n    padding: 8px 12px;\n    -webkit-tap-highlight-color: transparent;\n    width: 100%;\n    ",
    " &::placeholder {\n      color: ", ";\n    }\n    &:-ms-input-placeholder {\n      color: ", ";\n    }\n    &:hover,\n    &:focus {\n      border-color: ", ";\n    }\n    &:disabled {\n      background: ", ";\n      opacity: 0.3;\n      &:hover {\n        border-color: ", ";\n      }\n    }\n    &:read-only {\n      border: none;\n      padding: none;\n    }\n  }\n"])), function (_a) {
    var invalidMessage = _a.invalidMessage;
    return invalidMessage
        ? "1px solid " + Color.SOFT_RED
        : "1px solid " + Color.LIGHT_GRAY_2;
}, Color.COLOR_TEXT, Size.INPUT.HEIGHT, function (_a) {
    var align = _a.align;
    return align === 'right' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        text-align: right;\n      "], ["\n        text-align: right;\n      "])));
}, Color.LIGHT_GRAY_2, Color.LIGHT_GRAY_2, Color.VIVID_BLUE, Color.VERY_LIGHT_GRAY_5, Color.LIGHT_GRAY_2);
export default TextField;
var templateObject_1, templateObject_2;
//# sourceMappingURL=text-field.js.map